import {
  Popover,
  PopoverProps,
  PopoverArrow,
  PopoverContent,
  PopoverContentProps,
  PopoverTrigger,
  IconProps,
} from '@chakra-ui/react';
import { SCROLLBAR_WIDTH_PX } from 'app/constants';
import { TooltipIcon } from '..';

export interface InteractiveTooltipProps {
  children: React.ReactNode;
  popoverProps?: PopoverProps;
  popoverContentProps?: PopoverContentProps;
  showArrow?: boolean;
  iconProps?: IconProps;
  iconWidth?: number;
  variant?: 'dark' | 'light';
}

export const InteractiveTooltip = ({
  children,
  popoverProps,
  popoverContentProps,
  showArrow = true,
  iconProps,
  iconWidth = 6,
  variant = 'dark',
}: InteractiveTooltipProps) => {
  return (
    <Popover
      trigger="hover"
      {...popoverProps}
      modifiers={[
        {
          name: 'preventOverflow',
          options: {
            padding: SCROLLBAR_WIDTH_PX,
          },
        },
      ]}
    >
      <PopoverTrigger>
        <TooltipIcon w={iconWidth} {...iconProps} />
      </PopoverTrigger>
      <PopoverContent
        bg={variant === 'dark' ? 'black' : 'white'}
        p={2}
        border="none"
        outline="none"
        _focusVisible={{
          boxShadow: 'none',
        }}
        borderRadius={4}
        maxWidth={`calc(100vw - ${SCROLLBAR_WIDTH_PX * 2}px)`}
        {...popoverContentProps}
      >
        {showArrow ? (
          <PopoverArrow bg={variant === 'dark' ? 'black' : 'white'} />
        ) : null}
        {children}
      </PopoverContent>
    </Popover>
  );
};
